import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import LogoWhite from "../../assets/images/Logo-white.png";
import { Container } from '@mui/material';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppleIcon from '@mui/icons-material/Apple';
import ShopIcon from '@mui/icons-material/Shop';
import { LazyLoadImage } from 'react-lazy-load-image-component';



export default function DrawerAppBar({ window }) {
    const notify = () => toast("Coming soon");


    return (
        <Box className="top-new-navbar-css" sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar component="nav" className={`navbar`} position='relative'>
                <Container maxWidth="lg">
                    <Toolbar>
                        <Typography
                            variant="h6"
                            component="div"
                            sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}
                        >
                            <Link to="/">
                                <LazyLoadImage
                                    className='navbar-brand'
                                    src={LogoWhite}
                                    alt="Logo"
                                    loading="lazy"
                                />
                            </Link>
                        </Typography>
                        <Box sx={{ display: "flex" }}>
                            <Link onClick={notify}>
                                <Button className='nav-items nav-items-top-1'>
                                    <AppleIcon className='nav-items-top-1-1' /> <span className='hidde-mobile'>App Store</span>
                                </Button>
                            </Link>
                            <Link to="https://play.google.com/store/apps/details?id=com.kerdos.wallet" target='_blank'>
                                <Button className='nav-items nav-items-top-1'>
                                <ShopIcon className='nav-items-top-1-1' /> <span className='hidde-mobile'>Play Store</span>
                                </Button>
                            </Link>

                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>


        </Box >
    );
}
